import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { AuthContext } from "../../../AuthContextWrapper";
import { RadioAndResponseForm } from "../shared/RadioAndResponseForm";
import { Estate } from "../../../models/Estate";
import { EstateUserInfo } from "models/EstateUserInfo";

export enum Outcomes {
  spouse = "Spouse",
  child = "Child",
  parent = "Parent",
  sibling = "Sibling",
  other = "Other family member",
  notRelated = "Not related",
  somethingElse = "Something else",
}

export const RelationshipScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow, activeEstate, setActiveEstate, user } = useContext(AuthContext);
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (
    relationship: string,
    more?: string
  ): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    // const estate = activeEstate ? Estate.from(activeEstate) : new Estate();
    const estate = activeEstate || new Estate();

    if (estate.estateUserInfo) {
    } else {
      const estateUserInfo = new EstateUserInfo(undefined, user?.id, estate.id);
      estate.estateUserInfo = estateUserInfo;
    }

    estate.estateUserInfo.relationshipToDeceased = relationship;
    estate.estateUserInfo.relationshipToDeceasedMore = more || undefined;

    try {
      await estate.saveEstate();
      setActiveEstate && setActiveEstate(estate);
    } catch (error) {
      throw new Error("could not save data");
    }

    flow?.navigateToNext(currentScreen, relationship, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title={`What is your relationship to ${activeEstate?.deceasedFirstName}?`}
    >
      <RadioAndResponseForm
        initAnswer={activeEstate?.estateUserInfo?.relationshipToDeceased}
        initMoreAnswer={
          activeEstate?.estateUserInfo?.relationshipToDeceasedMore
        }
        answerLabel="Relationship"
        errorText={`Oops! We need to know your relationship to ${activeEstate?.deceasedFirstName}.`}
        options={[
          { value: Outcomes.spouse },
          { value: Outcomes.child },
          { value: Outcomes.parent },
          { value: Outcomes.sibling },
          { value: Outcomes.other },
          { value: Outcomes.notRelated },
          { value: Outcomes.somethingElse, followUp: "Tell us more" },
        ]}
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
